module.exports = "/_next/static/images/leaf-duotone-29f196c2a86ac97078a9d8aaf54dd7a2.svg";